import Axios, { AxiosRequestConfig } from 'axios';

import {
	_removeLocalStorageItem,
	_retrieveLocalStorageItem,
} from '../utils/localStorage';

const defaultOptions: AxiosRequestConfig = {
	baseURL: process.env.REACT_APP_BASE_URL,
	timeout: 30000,
};

export const axiosInstance = Axios.create(defaultOptions);

axiosInstance.interceptors.request.use(async (req) => {
	const accessToken = (await _retrieveLocalStorageItem('accessToken')) || null;
	if (accessToken) {
		req.headers.Authorization = `Bearer ${accessToken}`;
	}
	return req;
});

axiosInstance.interceptors.response.use(
	(response) => response,
	async (error) => {
		const status = error.response ? error.response.status : null;

		if (status === 401) {
			_removeLocalStorageItem('accessToken');
			window.location.replace('/');
		}

		throw error;
	},
);
